import {IBaseLookup} from "./Ibase.lookup";

export namespace UserGroup {

    export const lookupName: string = "UserGroup";

    export interface UserGroup {
        userGroupKey: number;
        name: string;
        description: string;
        lastUpdated: Date;
        defaultGuiActionKey: number;
        guiThemeKey: number;
        workstationLockTime: number;
        code: string;
        webIconKey: number;
        webTheme: string;
    }

    export interface UserXUserGroup {
        userXUserGroupKey: number;
        personKey: number;
        orgStructureKey: number;
        userGroupKey: number;
        lastUpdated: Date;
        isdefault: string;
        isemergency: string;
    }

    export interface UserGroupDS extends IBaseLookup {
        userGroup: UserGroup[];
        userXUserGroup: UserXUserGroup[];
    }
}
